import http from '../useHttp';
import { useApi } from '../useApi';

export const submitFeedbackComment = async (
  submissionId: string,
  feedback: string,
) => {
  return useApi(
    http.post('/llm/review/feedback', {
      feedback,
      submissionId,
    }),
  );
};
